import React, {useState} from 'react';
import Frame from "../components/layout/Frame";
import Container from "react-bootstrap/Container";
import {Col, Row} from "react-bootstrap";
import PopUp from "../components/popUp/PopUp";
import CMFWInfoBox from "../components/searchBoxs/CMFWInfoBox";
import FcltyFloorCtl from "../components/control/FcltyFloorCtl";
import FacilityStatus from "./subPages/FacilityStatus";
import FailurePerformance from "./subPages/FailurePerformance";
import DisabilityStatus from "./subPages/DisabilityStatus";
import FailureCards from "./subPages/FailureCards";

const DashPlatform = ({
                        propAuthInfo,
                        propAuth = undefined,
                      }) => {
  const [openLayer, setOpenLayer] = useState({isVisible: false, fcltyNo: 0, isSaved: false});

  const openLayerHandler = (fcltyNm = 0) => {
    let layer = {};
    if (openLayer.isVisible === true) {
      layer.isVisible = false;
      layer.fcltyNo = fcltyNm;
      layer.isSaved = true;
    } else {
      layer.isVisible = true;
      layer.fcltyNo = fcltyNm;
      layer.isSaved = true;
    }
    setOpenLayer(layer);
  };

  const closeLayerHandler = () => {
    setOpenLayer(prev => {
      return {...prev, isVisible: false}
    })
  };

  const [stSectionID, setSectionID] = useState('0');

  return (
      <Frame
          propIsActiveHeader={true}
          propIsActiveSidebar={true}
      >
        <PopUp
            propTitle={'시설 상태 정보'}
            propShow={openLayer.isVisible}
            setShow={closeLayerHandler}
            propDialogClassName={"modal-90w"}
        >
          <div className={'layer p-2'}>
            <CMFWInfoBox
                propFcltyID={openLayer.fcltyNo}
                propIsReadOnly={true}
                propLocation={"dash"}
            />
            <FcltyFloorCtl
                propFcltyID={openLayer.fcltyNo}
                propIsReadOnly={true}
                propLocation={"dash"}
            />
          </div>
        </PopUp>
        <Container fluid className={"dash-container"}>
          <Row className={"p-3 h-100"}>
            <Col md={12} className={"p-0"}>
              <Row className={''}>
                <Col xl={8} className={"ps-0"}>
                  {/* 시설 현황 */}
                  <FacilityStatus
                      openLayerHandler={openLayerHandler}
                      propInitState={propAuthInfo}
                      stSectionID={stSectionID}
                      setSectionID={setSectionID}
                      propAuth={propAuth}
                  />
                </Col>
                <Col xl={4} className={"ps-0"}>
                  {/* 장애 및 성능 */}
                  {/* 차트 변경 시 레이아웃 수정 필요*/}
                  {/*<FailurePerformance/>*/}
                  <FailureCards
                      propAtdrcId={stSectionID}
                  />
                </Col>
              </Row>
              <Row>
                <Col xl={12} className={"ps-0"}>
                  {/* 장애 현황 */}
                  <DisabilityStatus
                      openLayerHandler={openLayerHandler}
                      propAtdrcId={stSectionID}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </Frame>
  );
};

export default DashPlatform;
